import { createSelector } from '@ngrx/store';
import { get } from '../../../shared/utils/func';
import { featureState } from './feature.name';

export const uiState = createSelector(featureState, get('ui'));

export const publishSearchCriteria = createSelector(uiState, get('publishSearchCriteria'));

export const selectedInstallerIds = createSelector(uiState, get('selectedInstallerIds'));
